import { Accordion, Box, Heading } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDocumentsQuery } from 'generated/graphql';
import Folder from './Folder';
import { groupDocuments } from './lib';

function Files({ clientId }: { clientId: string }) {
  const { loading, data } = useDocumentsQuery({ variables: { clientId } });

  if (loading || !data) return null;

  const documents = data.documents.edges.map(edge => edge.node!);
  const folders = groupDocuments(documents);

  return (
    <Box p={8}>
      <Heading as="h4" size="md" mb={8}>
        <FontAwesomeIcon icon={['fal', 'box-archive']} /> Client Files
      </Heading>
      <Accordion allowToggle allowMultiple>
        <Folder
          name="Lease Application"
          documents={folders['Lease Application']}
          showAddButton
          type="lease"
        />
        {Object.entries(folders)
          .filter(([k]) => k !== 'Lease Application')
          .map(([name, files]) => (
            <Folder key={name} name={name} type="contract" documents={files} />
          ))}
      </Accordion>
    </Box>
  );
}

export default Files;
